<!-- Leadership Team Section -->
<section class="cyclops team-section" id="leadership">
  <div class="container">
    <h4 class="team-subtitle" style="padding: 20px;">LEADERSHIP TEAM</h4>
    <h2 class="section-title gradient-text text-center" style="color:#b70000; padding-bottom: 30px;">
      MEET OUR TEAM
    </h2>

    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 mb-4" *ngFor="let member of teamMembers">
        <div class="team-card">
          <div class="team-image">
            <img [src]="member.image" [alt]="member.name">
            <span class="corner top-left"></span>
            <span class="corner top-right"></span>
            <span class="corner bottom-left"></span>
            <span class="corner bottom-right"></span>
          </div>
          <h5 class="team-name">{{ member.name }}</h5>
          <p class="team-role" *ngIf="member.role1">{{ member.role1 }}</p>
          <p class="team-role" *ngIf="member.role2">{{ member.role2 }}</p>
          <p class="team-company">{{ member.company }}</p>
          <div class="btn-outline-danger btn-sm mt-2" (click)="openModal(member)">
            Read More
          </div>
        </div>
      </div>
    </div>

    <!-- Explore Button -->
    <div class="text-center mt-4">
      <a [routerLink]="['/about-us']" fragment="leadership" class="btn btn-danger explore-btn">
  Explore Our Team
</a>

    </div>
  </div>
</section>

<!-- Team Member Modal -->
<div class="custom-modal-backdrop" *ngIf="selectedMember">
  <div class="custom-modal">
    <span class="close-btn" (click)="closeModal()">&times;</span>
    <div class="modal-content-container">
      <!-- Image -->
      <div class="modal-image">
        <img [src]="selectedMember.image" [alt]="selectedMember.name">
      </div>
      <!-- Details -->
      <div class="modal-details">
        <h3>{{ selectedMember.name }}</h3>
        <p class="modal-role" *ngIf="selectedMember.role1">{{ selectedMember.role1 }}</p>
        <p class="modal-role" *ngIf="selectedMember.role2">{{ selectedMember.role2 }}</p>
        <p class="modal-company">{{ selectedMember.company }}</p>
        <div class="modal-description">
          {{ selectedMember.description }}
        </div>
      </div>
    </div>
  </div>
</div>
